import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAProductEnquiry,
  getProductEnquiries,
  resetState,
  updateAProductEnquiry,
} from "../features/productEnquiry/productEnquirySlice";
import { AiFillDelete, AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";
import { resolveMediaUrl } from "../utils/mediaUrl";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Product Image",
    dataIndex: "image",
  },
  {
    title: "Product Name",
    dataIndex: "product_name",
  },
  {
    title: "SKU / Design Code",
    dataIndex: "design_code",
  },
  {
    title: "Customer Name",
    dataIndex: "name",
  },
  {
    title: "Mobile",
    dataIndex: "mobile",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const ProductEnquiries = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [enqId, setEnqId] = useState("");
  
  const showModal = (e) => {
    setOpen(true);
    setEnqId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(resetState());
    dispatch(getProductEnquiries());
  }, [dispatch]);

  const enqState = useSelector((state) => state.productEnquiry.productEnquiries) || [];
  
  const data1 = [];
  for (let i = 0; i < enqState.length; i++) {
    data1.push({
      key: i + 1,
      image: (
        <img
          src={resolveMediaUrl(enqState[i].img)}
          alt={enqState[i].product_name}
          width={50}
          height={50}
          style={{ objectFit: 'cover', borderRadius: '4px' }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "default-product-img.png"; // Fallback image
          }}
        />
      ),
      product_name: enqState[i].product_name,
      design_code: enqState[i].design_code || 'N/A',
      name: enqState[i].name,
      mobile: enqState[i].mobile,
      status: (
        <>
          <select
            name=""
            defaultValue={enqState[i].status ? enqState[i].status : "Submitted"}
            className="form-control form-select"
            id=""
            onChange={(e) => setEnquiryStatus(e.target.value, enqState[i]._id)}
          >
            <option value="Submitted">Submitted</option>
            <option value="Contacted">Contacted</option>
            <option value="In Progress">In Progress</option>
            <option value="Resolved">Resolved</option>
          </select>
        </>
      ),
      action: (
        <>
          <Link
            className="ms-3 fs-3 text-danger"
            to={`/admin/product-enquiries/${enqState[i]._id}`}
          >
            <AiOutlineEye />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(enqState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }

  const setEnquiryStatus = (e, i) => {
    const data = { id: i, enquiryData: e };
    dispatch(updateAProductEnquiry(data));
  };

  const deleteEnq = (e) => {
    dispatch(deleteAProductEnquiry(e));
    setOpen(false);
    setTimeout(() => {
      dispatch(getProductEnquiries());
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Product Enquiries</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteEnq(enqId);
        }}
        title="Are you sure you want to delete this product enquiry?"
      />
    </div>
  );
};

export default ProductEnquiries;
